/*
 * @Author: luting
 * @Date: 2022-04-15 14:48:33
 * @lastEditors: luting
 * @LastEditTime: 2022-04-15 14:52:22
 */

// 根据所传的columnList从全部的columns中筛选出来
export const getRealUseColumns = (columnList: string[], columns: any) => {
  const realUseColumns: any = [];
  columns.forEach((element: any) => {
    if (columnList.includes(element.dataIndex)) {
      realUseColumns.push(element);
    }
  });

  return realUseColumns;
};
